// extracted by mini-css-extract-plugin
export default {"landingBody":"Landing_landingBody__LdSXp","btn":"Landing_btn__kUUh6","title":"Landing_title__k1yyD"};